type DebugPayload = Record<string, unknown> | undefined;

export const isInboxSyncDebugEnabled = (): boolean =>
  process.env.EXPO_PUBLIC_INBOX_SYNC_DEBUG === 'true';

export const logInboxSyncDebug = (
  event: string,
  payload?: DebugPayload,
): void => {
  if (!isInboxSyncDebugEnabled()) return;
  if (payload) {
    // eslint-disable-next-line no-console
    console.log(`[InboxSyncDebug] ${event}`, payload);
    return;
  }
  // eslint-disable-next-line no-console
  console.log(`[InboxSyncDebug] ${event}`);
};
